import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/blocks/Icon/Icon';
import SolimatLogoIcon from '../../../img/NewDesign/logo-pequeño.svg';
import useGetMainCenters from 'services/company/useGetMainCenters';
import { sortCentersByPriority } from 'utils/centerSorting';
import './InfoNew.scss';

const InfoNew: React.FC = () => {
  const navigate = useNavigate();
  const { getMainCenters, mainCenters } = useGetMainCenters();

  useEffect(() => {
    getMainCenters();
  }, []);

  const handleRedirectCenter = (id: string) => {
    navigate(`/red-de-centros/centro/${id}`);
  };

  const visibleMainCenters = sortCentersByPriority(mainCenters ?? []);

  return (
    <section className="section">
      <div className="container">
        <div className="section__head">
          <div>
            <h2 style={{fontSize:"38px"}}>Red de centros</h2>
            <p className="section__sub">Cerca de ti, siempre</p>
          </div>
          <button className="btn btn--ghost" onClick={() => navigate('/red-de-centros')}>
            Ver todos <Icon name="arrow-right" size={18} />
          </button>
        </div>
        <div className="centers">
          {visibleMainCenters.map((center: any, i: number) => {
            const tipoCentroId = Number(center.TipoCentroId);
            const isHospital = tipoCentroId === 4 || tipoCentroId === 5;
            const isSolimat = center.Descripcion?.toLowerCase().includes('solimat');
            const centerClasses = ['center', 'reveal', 'is-in'];
            if (isHospital) centerClasses.push('center--hospital');
            if (isSolimat) centerClasses.push('center--solimat');
            if (!isHospital && !isSolimat) centerClasses.push('center--centro');
            const patternId = `p-${center.Id || i}`;
            const addr = `${center.TipoViaDescripcion ?? ''} ${center.NombreCalle ?? ''} ${center.NumeroCalle ?? ''}, ${center.LocalidadDescripcion ?? ''}`.trim();
            return (
              <article
                key={center.Id || i}
                className={centerClasses.join(' ')}
                role="button"
                tabIndex={0}
                style={{ cursor: 'pointer' }}
                onClick={() => handleRedirectCenter(center.Id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleRedirectCenter(center.Id);
                  }
                }}
              >
                <div className="center__hero" aria-hidden>
                  <svg className="center__pattern" viewBox="0 0 200 120" preserveAspectRatio="none">
                    <defs>
                      <pattern id={patternId} width="22" height="22" patternUnits="userSpaceOnUse">
                        <circle cx="11" cy="11" r="1.4" fill="currentColor" opacity="0.35" />
                      </pattern>
                    </defs>
                    <rect width="200" height="120" fill={`url(#${patternId})`} />
                  </svg>
                  <div className="center__glyph">
                    {isSolimat
                      ? <img src={SolimatLogoIcon} alt="Solimat" className="center__glyph-logo" />
                      : isHospital
                        ? <Icon name="hospital" size={36} />
                        : <Icon name="shield" size={36} />}
                  </div>
                  {center.LocalidadDescripcion && (
                    <div className="center__city">
                      <Icon name="pin" size={14} /> {center.LocalidadDescripcion}
                    </div>
                  )}
                </div>
                <div className="center__body">
                  <div className="center__name">{center.Descripcion}</div>
                  <div className="center__addr">{addr}</div>
                  {center.Telefono && (
                    <a href={`tel:${center.Telefono}`} className="center__phone">
                      <Icon name="phone" size={16} /> {center.Telefono}
                    </a>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default InfoNew;

